import { render } from "./PopupConfirm.vue?vue&type=template&id=0a51cb20&scoped=true"
import script from "./PopupConfirm.vue?vue&type=script&lang=js"
export * from "./PopupConfirm.vue?vue&type=script&lang=js"

import "./PopupConfirm.vue?vue&type=style&index=0&id=0a51cb20&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a51cb20"]])

export default __exports__